module.exports = __webpack_public_path__ + "estacao-espacial-internacional.b0f26b3faec97edee97d34efc514b593.jpg";